import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from "react";
import elements from "./Paragraph.module.scss";
import { PortableText } from "@portabletext/react";
import { customComponentRenderers, observeCitationLayout, reflowCitations } from "./Citation";
export type ParagraphProps = {
  tocKey: string;
  title: string;
  blocks: any[];
};
export const Paragraph: React.FC<ParagraphProps> = t0 => {
  const $ = _c(13);
  const {
    title,
    tocKey,
    blocks
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(observeCitationLayout, t1);
  let t2;
  if ($[1] !== blocks) {
    t2 = [blocks];
    $[1] = blocks;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(_temp, t2);
  let t3;
  if ($[3] !== title || $[4] !== tocKey) {
    t3 = <p className="inngress" data-toc-key={tocKey}>{title}</p>;
    $[3] = title;
    $[4] = tocKey;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== blocks) {
    t4 = blocks || [];
    $[6] = blocks;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <PortableText value={t4} components={customComponentRenderers} />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className={elements.paragraphwrapper}>{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp() {
  reflowCitations();
}